/*
 * TENDON redesign - Pruvodce vyberem lana (rope wizard).
 *
 * Stav zije v URL (?rw=climb.crag.tough&rwl=60), kazdy krok je vlastni polozka
 * historie, takze BACK v prohlizeci funguje bez dalsiho kodu - staci popstate.
 *
 * Vysledky se tahaji z alternativni sablony kolekce (?view=pruvodce). Runtime id
 * sekce vypisu (template--NNN__main) se nikde nehada: prvni fetch jde na celou
 * stranku, id se precte z obalu, ktery vyrenderoval sam Shopify, a ulozi se do
 * sessionStorage - dalsi fetche uz jedou pres section_id a jsou o rad mensi.
 *
 * Sanity check: kdyz Search and Discovery neznamy facet tise ignoruje, vrati se
 * cela kolekce. Proto se porovnava vracene mnozstvi proti poctu bez facetu
 * (data-base) a proti celkovemu poctu lan. Kdyz kontrola neprojde, nezobrazi se
 * zadne karty - jen console.warn a fallback odkaz do katalogu.
 *
 * Bez JS zustane videt prvni krok (dlazdice jsou skutecne odkazy do kolekci)
 * a trvaly escape odkaz do katalogu.
 *
 * Cestina: pocet lan zna az JS, takze se vsechny mluvnicke tvary renderuji na serveru
 * (Shopify pluralizace one/few/many/other) a tady se jen vybira ten spravny podle
 * Intl.PluralRules. Zadne skladani retezcu v JS.
 *
 * Krokovac: "Krok X ze Y" se pocita z delky zvolene vetve - index = pocet zodpovezenych
 * otazek + 1, total = index + (data-depth aktualniho panelu - 1). Panel s vysledkem
 * zadnou depth nema a hlasi "Hotovo", takze jednokrokove vetve netvrdi "Krok 3 ze 3".
 */
(function () {
  'use strict';

  var PARAM_PATH = 'rw';
  var PARAM_LEN = 'rwl';
  var SID_KEY = 'tdn-rw-section-id';

  function isBanner(li) {
    return li.hasAttribute('data-tdn-banner') || li.classList.contains('tdn-cb-item');
  }

  function fill(str, map) {
    var out = String(str == null ? '' : str);
    Object.keys(map).forEach(function (k) {
      out = out.split('[' + k + ']').join(map[k]);
    });
    return out;
  }

  /* Vybere mluvnicky tvar. Vstupem je bud holy retezec, nebo mapa one/few/many/other
     vyrenderovana Shopify pluralizaci na serveru. */
  function plural(value, n, rules) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    var form = 'other';
    if (rules) {
      try { form = rules.select(n); } catch (err) { form = 'other'; }
    }
    return value[form] != null ? value[form] : (value.other != null ? value.other : '');
  }

  /* Cte strojovou hodnotu z data-tdn-*. Chybejici atribut = null, nikdy 0 -
     rozdil mezi "nula pádů" a "nevíme" musi zustat citelny. */
  function attrNum(li, name) {
    var raw = li.getAttribute('data-tdn-' + name);
    if (raw === null || raw === '') return null;
    var n = parseFloat(raw);
    return isNaN(n) ? null : n;
  }

  /* Zobrazovana cena za metr v celych korunach. Renderuje ji Liquid do
     data-tdn-ppm-czk; nouzovy prepocet z haleru je jen pojistka, aby superlativ
     nikdy nespadl na nulu, kdyby atribut chybel. */
  function ppmDisp(li) {
    var c = attrNum(li, 'ppm-czk');
    if (c !== null) return c;
    var p = attrNum(li, 'ppm');
    return p === null ? null : Math.round(p / 100);
  }

  /* O kolik je minimum pod zbytkem vyberu. Median zbytku, ne prumer a ne druha
     nejnizsi hodnota: prumer utahne jeden vystrelek, druha nejnizsi zas nerekne
     nic o skupine. Pro paticu 63,90 / 77,00 / 78,87 / 80,70 / 81,43 vyjde 20 %.
     "Zbytek" = vsechno, co na minimu NESTOJI. Pri remize na prvnim miste by
     odseknuti jedine polozky nechalo druheho viteze v porovnavane skupine a
     procento by tvrdilo, ze je minimum pod hodnotou, ktera se mu rovna. */
  function relBelowRest(values, min) {
    var rest = values.filter(function (v) { return v !== min; })
      .sort(function (a, b) { return a - b; });
    if (!rest.length) return 0;
    var mid = Math.floor(rest.length / 2);
    var med = rest.length % 2 ? rest[mid] : (rest[mid - 1] + rest[mid]) / 2;
    if (!med) return 0;
    return (med - min) / med;
  }

  /* Prah viditelnosti parametru ve vysledku: parametr, ktery nezna vic nez 30 %
     lan, se nezobrazuje ani v radku "Shodne u vsech", ani jako fakticky cip.
     Pravidlo 4 (priznani chybejicich dat) musi pouzivat TENTYZ prah - jinak by
     v okne 30-50 % neznamych lano dostalo vetu "Technicke parametry doplnujeme."
     za parametr, ktery na strance nikde neni. */
  function paramVisible(unknown, n) {
    return unknown * 10 <= n * 3;
  }

  /* Radek "Shodne u vsech" i cipy jednoho lana casto nesou tutez informaci dvakrat
     (typ produktu "Statické lano" + certifikace "Statické"). Zahodime tu polozku,
     ktera je doslovnym podretezcem jine - delsi, konkretnejsi text zustava. */
  function dropRedundant(texts) {
    var low = texts.map(function (t) { return (t || '').toLowerCase().trim(); });
    return texts.map(function (t, i) {
      if (!low[i]) return false;
      return low.some(function (s, j) {
        return j !== i && s.length > low[i].length && s.indexOf(low[i]) >= 0;
      });
    });
  }

  class RopeWizard extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.root = this.dataset.root || '';
      this.view = this.dataset.view || 'pruvodce';
      this.lenKey = this.dataset.lenKey || '';
      this.totalRopes = parseInt(this.dataset.totalRopes, 10) || 48;
      this.catalogUrl = this.dataset.catalogUrl || this.root + '/collections/lana';
      this.locale = this.dataset.locale || 'cs';
      this.pushes = 0;
      this.reqToken = 0;
      this.sortOverride = null;
      // Facetova alternativa ("Lehci"/"Odolnejsi") prepnuta na miste - drzi facety,
      // ocekavany pocet a texty oduvodneni prevzate z data-alt*-* atributu dlazdice.
      this.altPick = null;
      this.lastChain = null;
      this.lastLen = null;
      this.lastNode = null;

      try {
        this.plurals = new Intl.PluralRules(this.locale);
      } catch (err) {
        this.plurals = null;
      }

      var raw = this.querySelector('[data-rw-i18n]');
      try {
        this.i18n = raw ? JSON.parse(raw.textContent) : {};
      } catch (err) {
        this.i18n = {};
      }

      try {
        this.sectionId = sessionStorage.getItem(SID_KEY) || null;
      } catch (err) {
        this.sectionId = null;
      }

      this.panels = {};
      var self = this;
      this.querySelectorAll('[data-panel]').forEach(function (p) {
        self.panels[p.dataset.panel] = p;
      });

      this.tiles = {};
      this.querySelectorAll('[data-panel] [data-answer]').forEach(function (el) {
        var panel = el.closest('[data-panel]').dataset.panel;
        if (!self.tiles[panel]) self.tiles[panel] = {};
        self.tiles[panel][el.dataset.answer] = el;
        el.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button > 0) return;
          ev.preventDefault();
          self.choose(panel, el.dataset.answer);
        });
      });

      this.progressBox = this.querySelector('[data-rw-progress]');
      this.barFill = this.querySelector('[data-rw-bar-fill]');
      this.bar = this.querySelector('[data-rw-bar]');
      this.stepLabel = this.querySelector('[data-rw-step-label]');
      this.backBtn = this.querySelector('[data-rw-back]');

      /* Deska s odduvodnenim se stehuje do oznaceneho radku (viz markPick). Radky ale
         pri kazdem prekresleni mizi (gridBox.innerHTML = ''), takze si drzime, kam
         deska patri, a pred kazdym prekreslenim ji vratime domu. Bez toho by ji druhy
         render smazal spolu s mrizkou. */
      this.pickBox = this.querySelector('[data-rw-pick]');
      if (this.pickBox) {
        this.pickHome = this.pickBox.parentNode;
        this.pickAnchor = this.pickBox.nextSibling;
      }

      /* Delka: souhrn na jeden radek, detaily az na klik. */
      this.lenToggle = this.querySelector('[data-rw-len-toggle]');
      this.lenMore = this.querySelector('[data-rw-len-more]');
      if (this.lenToggle && this.lenMore) {
        this.lenToggle.addEventListener('click', function () {
          var open = self.lenMore.hidden;
          self.lenMore.hidden = !open;
          self.lenToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          var i18n = self.i18n || {};
          self.lenToggle.textContent = open
            ? (i18n.length_hide || self.lenToggle.textContent)
            : (i18n.length_change || self.lenToggle.textContent);
        });
      }

      if (this.backBtn) {
        this.backBtn.addEventListener('click', function () {
          self.goBack();
        });
      }
      this.querySelectorAll('[data-rw-restart]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setState([], null, true);
        });
      });
      this.querySelectorAll('[data-rw-len]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.setLength(btn.dataset.rwLen);
        });
      });
      this.querySelectorAll('[data-rw-region-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.querySelectorAll('[data-rw-region-btn]').forEach(function (o) {
            o.classList.remove('is-on');
            o.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add('is-on');
          btn.setAttribute('aria-pressed', 'true');
          self.setLength(btn.dataset.len);
        });
      });
      this.querySelectorAll('[data-rw-alt]').forEach(function (a) {
        a.addEventListener('click', function (ev) {
          if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button > 0) return;
          var node = self.lastNode;
          if (!node) return;
          var n = a.dataset.rwAlt;
          var nd = node.dataset;
          var key = nd['alt' + n + 'Sort'];
          if (key) {
            // Cista zmena razeni tehoz vyberu (osa "levnejsi").
            ev.preventDefault();
            self.sortOverride = self.sortOverride === key ? null : key;
            self.applySort();
            self.syncAltState();
            return;
          }
          var facets = nd['alt' + n + 'Facets'];
          // Bez data-alt*-facets je to obycejny odkaz do kolekce - nechat projit.
          if (facets === undefined) return;
          // Facetova alternativa se prepina NA MISTE - stejne chovani, jake ma
          // razeni "levnejsi": prvni klik prepne vyber, druhy vrati puvodni,
          // jina odpoved stav zahodi. Odkaz v href zustava fallbackem bez JS.
          ev.preventDefault();
          if (self.altPick && self.altPick.n === n) {
            self.altPick = null;
          } else {
            self.altPick = {
              n: n,
              facets: facets,
              expect: parseInt(nd['alt' + n + 'Expect'], 10),
              diam: nd['alt' + n + 'Diam'] || '',
              band: nd['alt' + n + 'Band'] || '',
              tradeoff: nd['alt' + n + 'Tradeoff'] || '',
              sort: nd['alt' + n + 'Sortx'] || ''
            };
            self.sortOverride = null;
          }
          if (self.lastChain) self.renderResult(self.lastChain, self.lastLen, false);
        });
      });

      var retry = this.querySelector('[data-rw-retry]');
      if (retry) {
        retry.addEventListener('click', function () {
          self.render(true);
        });
      }

      window.addEventListener('popstate', function () {
        self.render();
      });

      this.render();
    }

    /* ---------- stav ---------- */

    readState() {
      var params = new URLSearchParams(window.location.search);
      var path = (params.get(PARAM_PATH) || '').split('.').filter(Boolean);
      var len = params.get(PARAM_LEN);
      return { path: path, length: len };
    }

    setState(path, length, replace) {
      var params = new URLSearchParams(window.location.search);
      if (path && path.length) {
        params.set(PARAM_PATH, path.join('.'));
      } else {
        params.delete(PARAM_PATH);
      }
      if (length) {
        params.set(PARAM_LEN, length);
      } else {
        params.delete(PARAM_LEN);
      }
      var qs = params.toString();
      var url = window.location.pathname + (qs ? '?' + qs : '');
      if (replace) {
        window.history.replaceState({ rw: 1 }, '', url);
      } else {
        window.history.pushState({ rw: 1 }, '', url);
        this.pushes += 1;
      }
      this.render();
    }

    choose(panel, key) {
      var chain = this.resolve(this.readState().path).chain;
      var idx = -1;
      for (var i = 0; i < chain.length; i++) {
        if (chain[i].panel === panel) { idx = i; break; }
      }
      var path = chain.slice(0, idx === -1 ? chain.length : idx).map(function (c) { return c.key; });
      path.push(key);
      this.setState(path, null, false);
    }

    goTo(index) {
      var chain = this.resolve(this.readState().path).chain;
      var path = chain.slice(0, index).map(function (c) { return c.key; });
      this.setState(path, null, false);
    }

    goBack() {
      if (this.pushes > 0) {
        window.history.back();
        return;
      }
      var chain = this.resolve(this.readState().path).chain;
      this.goTo(Math.max(0, chain.length - 1));
    }

    setLength(len) {
      var st = this.readState();
      this.setState(st.path, len, true);
    }

    /* Prevede cestu na retez uzlu. Neznamy krok = neplatny odkaz. */
    resolve(path) {
      var panel = 'q1';
      var chain = [];
      var stale = false;
      for (var i = 0; i < path.length; i++) {
        var step = this.tiles[panel];
        var el = step ? step[path[i]] : null;
        if (!el) { stale = true; break; }
        chain.push({ panel: panel, key: path[i], el: el });
        panel = el.dataset.next || 'result';
        if (panel === 'result' || panel === 'b2b') break;
      }
      return { chain: chain, panel: panel, stale: stale };
    }

    /* ---------- render ---------- */

    render(force) {
      var st = this.readState();
      var res = this.resolve(st.path);
      var self = this;

      if (res.stale) {
        console.warn('[rope-wizard] neplatna cesta v URL, vracim na zacatek:', st.path.join('.'));
        this.setState([], null, true);
        return;
      }

      var current = res.chain.length ? res.chain[res.chain.length - 1].el.dataset.next : 'q1';
      if (!res.chain.length) current = 'q1';
      if (!this.panels[current]) current = 'q1';

      Object.keys(this.panels).forEach(function (id) {
        self.panels[id].hidden = id !== current;
      });

      /* Uvodni odstavec a odkaz do katalogu patri k prvni otazce. Jakmile padne
         prvni odpoved, CSS je schova (trida --started) - u vysledku by to bylo
         ~200 px, ktere uz nikdo necte. */
      this.classList.toggle('tdn-r-rw--started', res.chain.length > 0);

      this.renderProgress(current, res.chain);
      this.markChosen(res.chain);

      if (current === 'result') {
        this.renderResult(res.chain, st.length, force);
      }

      // Scroll a presun fokusu jen pri skutecne zmene kroku. Prepnuti delky prekresluje
      // tyz panel a nesmi uzivateli uskocit pod rukama ani mu sebrat fokus z pilulky.
      var changed = current !== this.lastPanel;
      this.lastPanel = current;
      if (res.chain.length && this.pushes > 0 && changed) {
        var panelEl = this.panels[current];
        // Auto-scroll jen pod 1024 px: na mobilu byva dalsi panel pod ohybem.
        // Na desktopu je pruvodce videt cely a odskok stranky po kazde odpovedi
        // pusobil rusive (pozadavek klienta 2026-07-29). Fokus se presouva dal -
        // focusPanel pouziva preventScroll, takze stranka stoji.
        var deskNoScroll = typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 1024px)').matches;
        if (!deskNoScroll && panelEl && typeof panelEl.scrollIntoView === 'function') {
          panelEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.focusPanel(panelEl);
      }
    }

    /* Po prechodu na dalsi krok musi fokus skoncit na nadpisu noveho panelu, jinak
       uzivatel klavesnice i ctecky spadne na zacatek dokumentu a o zmene se nedozvi.
       Nadpisy maji tabindex="-1", takze je lze zaostrit programove, ale ne tabem. */
    focusPanel(panelEl) {
      if (!panelEl) return;
      var target = panelEl.querySelector('[data-rw-focus]');
      if (!target || typeof target.focus !== 'function') return;
      try {
        target.focus({ preventScroll: true });
      } catch (err) {
        target.focus();
      }
    }

    /* Aktivni volba nesmi byt poznat jen barvou pozadi. */
    markChosen(chain) {
      var chosen = {};
      chain.forEach(function (item) {
        chosen[item.panel + '/' + item.key] = true;
      });
      this.querySelectorAll('[data-panel] [data-answer]').forEach(function (el) {
        var panel = el.closest('[data-panel]').dataset.panel;
        if (chosen[panel + '/' + el.dataset.answer]) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }

    renderProgress(current, chain) {
      if (!this.progressBox) return;
      var showing = chain.length > 0;
      this.progressBox.hidden = !showing;
      if (this.backBtn) this.backBtn.hidden = !showing;
      if (!showing) return;

      var panelEl = this.panels[current];
      var depth = parseInt(panelEl && panelEl.dataset.depth, 10);
      var label;
      var pct;

      if (!depth) {
        // Panel bez hloubky = konec vetve (vysledek nebo B2B). Zadne "Krok X ze Y",
        // protoze vetve maji ruznou delku a cislo by lhalo.
        pct = 100;
        label = this.i18n.progress_done || '';
      } else {
        var index = chain.length + 1;
        var total = index + depth - 1;
        pct = Math.round(((index - 1) / total) * 100);
        label = fill(this.i18n.progress, { current: index, total: total });
      }

      if (this.barFill) this.barFill.style.width = pct + '%';
      if (this.bar) this.bar.setAttribute('aria-valuenow', String(pct));
      if (this.stepLabel && this.stepLabel.textContent !== label) {
        this.stepLabel.textContent = label;
      }
      // "Hotovo" na vysledku nic nepridava - to same rikaji pilulky odpovedi
      // i nadpis. Progres bar zustava, jen bez textoveho popisku.
      if (this.stepLabel) this.stepLabel.hidden = !depth;
    }

    renderChips(chain, len) {
      var box = this.querySelector('[data-rw-chips]');
      if (!box) return;
      var self = this;
      box.querySelectorAll('[data-rw-chip]').forEach(function (c) { c.remove(); });
      chain.forEach(function (item, i) {
        var label = item.el.querySelector('.tdn-r-rw__tile-label');
        var text = label ? label.textContent.trim() : item.key;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tdn-r-rw__chip tdn-r-rw__chip--removable';
        btn.setAttribute('data-rw-chip', '');
        var span = document.createElement('span');
        span.textContent = text;
        btn.appendChild(span);
        // Odebrani cipu = zkraceni cesty na dany krok. Jedine chovani, ktere
        // nerozbije ?rw= jako jediny zdroj pravdy: zkracena cesta je vzdy platna
        // cesta stromem, takze resolve() ji precte bez stale a data-base/data-expect
        // predchoziho kroku dal plati. Uvolnovani facetu na miste zustava tam, kam
        // patri - v tlacitku "Zobrazit sirsi vyber".
        var x = document.createElement('span');
        x.className = 'tdn-r-rw__chip-x';
        x.setAttribute('aria-hidden', 'true');
        x.textContent = '\u00d7';
        btn.appendChild(x);
        var hint = fill(self.i18n.cmp_chip_remove || '', { answer: text });
        btn.title = hint;
        btn.setAttribute('aria-label', hint);
        btn.addEventListener('click', function () { self.goTo(i); });
        box.appendChild(btn);
      });
      var lenChip = document.createElement('button');
      lenChip.type = 'button';
      lenChip.className = 'tdn-r-rw__chip tdn-r-rw__chip--ghost is-on';
      lenChip.setAttribute('data-rw-chip', '');
      lenChip.textContent = fill(this.i18n.length_title, { length: len });
      // Delkovy cip krizek nedostava - delka neni krok cesty a odebrat ji nejde.
      lenChip.title = this.i18n.cmp_chip_length || this.i18n.change || '';
      lenChip.setAttribute('aria-label', lenChip.title);
      lenChip.addEventListener('click', function () {
        var block = self.querySelector('[data-rw-length-block]');
        if (block) block.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      box.appendChild(lenChip);
    }

    renderResult(chain, lengthOverride, force) {
      if (!chain.length) return;
      var node = chain[chain.length - 1].el;
      var d = node.dataset;
      var len = lengthOverride || d.len || '60';
      var self = this;
      var i18n = this.i18n;

      // Rucne zvolene razeni i facetova alternativa plati jen pro jeden vysledek;
      // jina odpoved je zahodi.
      if (this.lastNode !== node) {
        this.sortOverride = null;
        this.altPick = null;
      }
      this.lastNode = node;
      this.lastChain = chain;
      this.lastLen = lengthOverride;

      this.renderChips(chain, len);

      var title = this.querySelector('[data-rw-result-title]');
      if (title) {
        title.textContent = (d.pro ? i18n.pro_title : i18n.result_title) || title.textContent;
      }

      // Delka
      var lenTitle = this.querySelector('[data-rw-length-title]');
      if (lenTitle) lenTitle.textContent = fill(i18n.length_title, { length: len });
      this.querySelectorAll('[data-rw-len]').forEach(function (btn) {
        var on = btn.dataset.rwLen === String(len);
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var region = this.querySelector('[data-rw-region]');
      if (region) region.hidden = !d.region;
      this.querySelectorAll('[data-rw-region-btn]').forEach(function (btn) {
        var on = btn.classList.contains('is-on');
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // Bloky "nevim", dve lana, OOP
      var unsure = this.querySelector('[data-rw-unsure]');
      var unsureText = this.querySelector('[data-rw-unsure-text]');
      var unsureCta = this.querySelector('[data-rw-unsure-cta]');
      if (unsure) {
        var key = d.unsure ? i18n['unsure_' + d.unsure] : null;
        unsure.hidden = !key;
        if (key && unsureText) unsureText.textContent = key;
        if (unsureCta) unsureCta.hidden = !d.advice;
      }
      var two = this.querySelector('[data-rw-two]');
      if (two) two.hidden = !d.two;
      var ppe = this.querySelector('[data-rw-ppe]');
      if (ppe) ppe.hidden = !d.pro;

      // Doporuceni / profesionalni vetev
      var pick = this.querySelector('[data-rw-pick]');
      var pro = this.querySelector('[data-rw-pro]');
      if (pick) pick.hidden = true;
      if (pro) pro.hidden = !d.pro;
      var summaryBox = this.querySelector('[data-rw-summary]');
      if (summaryBox) summaryBox.hidden = true;

      var why = this.querySelector('[data-rw-pick-why]');
      if (why && !d.pro) {
        why.innerHTML = '';
        // Pri aktivni facetove alternative mluvi radek o prumeru za NI, ne za
        // puvodni dlazdici - jinak by seznam ukazoval jina lana, nez o kterych
        // oduvodneni tvrdi, ze tam jsou.
        var diamText;
        if (this.altPick && this.altPick.diam) {
          diamText = fill(i18n['diam_' + this.altPick.diam], { band: this.altPick.band || '' });
        } else if (d.diam === 'open' || !d.diam) {
          diamText = i18n.diam_open;
        } else {
          diamText = fill(i18n['diam_' + d.diam], { band: d.band || '' });
        }
        [
          i18n['cert_' + (d.cert || 'single')],
          diamText,
          fill(i18n.reason_length, { length: len, why: i18n['why_' + (d.why || 'crag')] || '' })
        ].forEach(function (text) {
          if (!text) return;
          var li = document.createElement('li');
          li.textContent = text;
          why.appendChild(li);
        });
      }
      var tradeoff = this.querySelector('[data-rw-pick-tradeoff]');
      var tradeoffKey = (this.altPick && this.altPick.tradeoff) || d.tradeoff || 'open';
      if (tradeoff) tradeoff.textContent = i18n['tradeoff_' + tradeoffKey] || '';

      // Alternativy pojmenovane osou kompromisu
      var alts = this.querySelector('[data-rw-alts]');
      if (alts) {
        // Staci jedna alternativa - dlazdice s jedinou smysluplnou osou (hory maji
        // jen "levnejsi") nemusi vymyslet druhou do poctu; karta bez URL se schova.
        var has = !!(d.alt1Url || d.alt2Url);
        alts.hidden = !has;
        if (has) {
          [1, 2].forEach(function (n) {
            var a = self.querySelector('[data-rw-alt="' + n + '"]');
            if (!a) return;
            var url = d['alt' + n + 'Url'];
            a.hidden = !url;
            if (!url) return;
            var axis = d['alt' + n];
            a.href = url;
            // Osa "levnejsi" uz nevede pryc do kolekce serazene podle CELKOVE ceny
            // (Alpine 7.9 s navinem 20 m tam vypada jako nejlevnejsi lano v nabidce),
            // ale prerazuje tyz vysledek podle ceny za metr. href zustava jako
            // fallback bez JS.
            var sortKey = d['alt' + n + 'Sort'];
            if (sortKey) {
              a.dataset.rwAltSort = sortKey;
            } else {
              delete a.dataset.rwAltSort;
            }
            a.querySelector('[data-rw-alt-axis]').textContent = i18n['alt_' + axis] || '';
            a.querySelector('[data-rw-alt-text]').textContent = i18n['alt_' + axis + '_desc'] || '';
          });
        }
      }
      this.syncAltState();

      // Uvolneni kriteria (cesty, kde zbyvaji dve lana)
      var relax = this.querySelector('[data-rw-relax]');
      if (relax) relax.hidden = true;

      this.loadResults(node, len, force);
    }

    /* ---------- fetch vysledku ---------- */

    /* Aktivni facetova alternativa NAHRAZUJE facety dlazdice (nemichaji se) -
       alternativa je jiny rez toutez kolekci, ne zuzeni puvodniho. */
    activeFacets(node) {
      return this.altPick ? this.altPick.facets : node.dataset.facets;
    }

    fetchUrl(node, withSectionId) {
      var parts = [];
      var facets = this.activeFacets(node);
      if (facets) parts.push(facets);
      parts.push('view=' + encodeURIComponent(this.view));
      if (withSectionId && this.sectionId) {
        parts.push('section_id=' + encodeURIComponent(this.sectionId));
      }
      return this.root + '/collections/' + node.dataset.coll + '?' + parts.join('&');
    }

    catalogLink(node, len) {
      var parts = [];
      var facets = this.activeFacets(node);
      if (facets) parts.push(facets);
      if (this.lenKey && len) parts.push(this.lenKey + '=' + encodeURIComponent(len));
      return this.root + '/collections/' + node.dataset.coll + (parts.length ? '?' + parts.join('&') : '');
    }

    /* Doporucena delka se do odkazu na produkt nepropisuje pres ?variant= (varianta je
       dvojice Barva x Delka, takze by pruvodce zvolil za zakaznika i barvu, a ID variant
       jsou natvrdo zadratovana cisla - viz data-shrnuti.md). Misto toho jde do URL
       neinvazivni ?dl=<metry>, ktere PDP muze predvybrat, a kdyz ho neprecte, nic se
       nedeje. Delkova facet je zaroven v odkazu "Zobrazit vsech N" (catalogLink). */
    applyLength(len) {
      if (!len) return;
      this.querySelectorAll('[data-rw-grid] a[href*="/products/"]').forEach(function (a) {
        var href = a.getAttribute('href');
        if (!href) return;
        href = href.replace(/([?&])dl=[^&]*/, '$1').replace(/[?&]$/, '');
        a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'dl=' + encodeURIComponent(len));
      });
    }

    loadResults(node, len, force) {
      var self = this;
      var loading = this.querySelector('[data-rw-loading]');
      var block = this.querySelector('[data-rw-results-block]');
      var errBox = this.querySelector('[data-rw-error]');
      var token = ++this.reqToken;

      if (loading) loading.hidden = false;
      if (block) block.hidden = true;
      if (errBox) errBox.hidden = true;

      var signature = this.fetchUrl(node, false);
      if (!force && this.lastSignature === signature && this.lastOk) {
        // Zmena delky nemeni vyber (delka nefiltruje), takze se znovu nefetchuje -
        // jen se prekresli to, co na delce zavisi.
        if (loading) loading.hidden = true;
        if (block) block.hidden = false;
        // Nadpis s poctem plni paint(); pri navratu z cache (napr. zpet v historii
        // nebo prepnuti delky) by jinak zustal bez poctu.
        var cachedTitle = this.querySelector('[data-rw-result-title]');
        if (cachedTitle && this.i18n.result_title_count && typeof this.lastTotal === 'number') {
          cachedTitle.textContent = fill(plural(this.i18n.result_title_count, this.lastTotal, this.plurals), { n: this.lastTotal });
        }
        var pickBox = this.querySelector('[data-rw-pick]');
        var gridUl = this.querySelector('[data-rw-grid] ul');
        if (pickBox) pickBox.hidden = !!node.dataset.pro || !(gridUl && gridUl.firstElementChild);
        var summaryBox = this.querySelector('[data-rw-summary]');
        if (summaryBox) summaryBox.hidden = !(gridUl && gridUl.firstElementChild) || summaryBox.textContent.trim() === '';
        this.updateShowAll(node, len, this.lastTotal);
        this.maybeRelax(node, len, this.lastTotal || 0);
        this.applyLength(len);
        return;
      }
      this.lastSignature = signature;
      this.lastOk = false;

      var usedSid = !!this.sectionId;
      fetch(this.fetchUrl(node, true), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (token !== self.reqToken) return;
          self.paint(node, len, html, usedSid);
        })
        .catch(function (err) {
          if (token !== self.reqToken) return;
          // 404 ze Section Rendering API znamena nejcasteji neplatne cachovane
          // section_id (template soubor se prepsal a ma nove TID) - overeno:
          // ?section_id=template--999999__main vraci 404 s prazdnym telem.
          if (self.dropSectionId(node, len, usedSid, err)) return;
          console.warn('[rope-wizard] nacteni vysledku selhalo:', err);
          self.showError('error_load', node, len);
        });
    }

    paint(node, len, html, usedSid) {
      var loading = this.querySelector('[data-rw-loading]');
      var block = this.querySelector('[data-rw-results-block]');
      var gridBox = this.querySelector('[data-rw-grid]');
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = doc.getElementById('product-grid');

      if (!grid) {
        // Sablona vratila prazdny vypis, nebo neco jineho, nez cekame.
        var emptyMarker = doc.querySelector('#filter-results');
        if (emptyMarker) {
          this.showEmpty(node, len);
        } else if (this.dropSectionId(node, len, usedSid)) {
          return;
        } else {
          console.warn('[rope-wizard] v odpovedi neni #product-grid');
          this.showError('error_load', node, len);
        }
        return;
      }

      var wrap = grid.closest('[id^="shopify-section-"]');
      if (wrap && wrap.id) {
        this.sectionId = wrap.id.replace(/^shopify-section-/, '');
        try { sessionStorage.setItem(SID_KEY, this.sectionId); } catch (err) { /* private mode */ }
        this.absorbAssets(doc, wrap);
      } else {
        this.absorbAssets(doc, null);
      }

      var items = Array.prototype.slice.call(grid.children).filter(function (li) {
        return li.tagName === 'LI' && !isBanner(li);
      });
      // Celkovy pocet se bere z paginace, ne z delky pole. Overeno na kolekci lana
      // (52 polozek, stranka 24): jakmile vysledek presahne stranku, sablona vyrenderuje
      // <load-more-products data-total="52">. Kdyz element chybi, vysledek se na jednu
      // stranku vesel a items.length JE cely pocet - vc. hranicniho pripadu presne 24.
      // Strop stranky je 24 natvrdo v schematu sekce main-collection, zvysit ho nejde.
      var lm = doc.querySelector('load-more-products[data-total]');
      var total = lm ? parseInt(lm.dataset.total, 10) : items.length;
      if (!total && total !== 0) total = items.length;

      if (!this.sane(node, total)) return;

      if (total === 0 || !items.length) {
        this.showEmpty(node, len);
        return;
      }

      if (gridBox) {
        // Doporucene lano se z vypisu NEVYTRHAVA. Zustava v seznamu a oznaci ho
        // markPick() az po serazeni - jinak by nejlehci lano chybelo v seznamu,
        // ktery o sobe tvrdi, ze je serazeny od nejlehciho.
        // POZOR: deska s odduvodnenim je v tehle chvili nastehovana uvnitr radku,
        // takze ji nejdriv vratime domu - jinak by ji innerHTML smazalo.
        this.restorePick();
        gridBox.innerHTML = '';
        var ul = document.createElement('ul');
        ul.className = grid.className;
        ul.setAttribute('role', 'list');
        items.forEach(function (li) { ul.appendChild(li); });
        gridBox.appendChild(ul);
      }

      // Pocet lan nese NADPIS, ne samostatny podtitulek pod nim - dve vety hned
      // pod sebou rikaly totez ("Tohle ti sedne" / "6 lan odpovida tvym odpovedim").
      var title = this.querySelector('[data-rw-result-title]');
      if (title && this.i18n.result_title_count) {
        title.textContent = fill(plural(this.i18n.result_title_count, total, this.plurals), { n: total });
      }
      var sub = this.querySelector('[data-rw-result-sub]');
      if (sub) {
        sub.textContent = '';
        sub.hidden = true;
      }
      var label = this.querySelector('[data-rw-results-label]');
      if (label) label.textContent = this.i18n.results_label || '';
      var proText = this.querySelector('[data-rw-pro-text]');
      if (proText) proText.textContent = this.i18n.pro_text || '';

      this.lastTotal = total;
      this.decorate(node);
      this.updateShowAll(node, len, total);
      this.maybeRelax(node, len, total);
      this.applyLength(len);

      if (loading) loading.hidden = true;
      if (block) block.hidden = false;
      this.lastOk = true;
    }

    updateShowAll(node, len, total) {
      var link = this.querySelector('[data-rw-showall]');
      if (!link) return;
      link.href = this.catalogLink(node, len);
      if (typeof total === 'number' && !isNaN(total)) {
        link.textContent = fill(plural(this.i18n.result_show_all, total, this.plurals), { n: total });
      }
    }

    /* Nabidka rozsireni. Pocet po uvolneni je prosty soucet data-expect sousednich
       pasem prumeru (jsou disjunktni), takze se nemusi delat druhy fetch. Delta se
       ale pocita z DORUCENEHO poctu, ne z data-expect - kdyz se katalog rozejde
       s pruvodcem, cislo v nabidce je pak porad aspon napul pravdive. */
    maybeRelax(node, len, total) {
      var relax = this.querySelector('[data-rw-relax]');
      if (!relax) return;
      // Nabidka uvolneni pocita se zakladnimi facety dlazdice; pri aktivni
      // alternative by soucty nesedely - radsi ji schovat.
      if (this.altPick) {
        relax.hidden = true;
        return;
      }
      var url = node.dataset.relaxUrl;
      var expect = parseInt(node.dataset.relaxExpect, 10);
      var delta = isNaN(expect) ? NaN : expect - total;
      var few = total > 0 && total <= 2;
      var show = !!url && total > 0 && (few || delta > 0);
      relax.hidden = !show;
      if (!show) return;
      var title = this.querySelector('[data-rw-relax-title]');
      var lead = this.querySelector('[data-rw-relax-lead]');
      var text = this.querySelector('[data-rw-relax-text]');
      var deltaBox = this.querySelector('[data-rw-relax-delta]');
      var link = this.querySelector('[data-rw-relax-link]');
      // Popisek uvolneni zavisi na kriteriu I na smeru. U prumeru uzel rika
      // data-relax-dir="down", kdyz sousedni pasmo lezi u TENCICH lan; bez toho
      // by jeden uzel (skaly/odolnost) tvrdil pravy opak toho, co odkaz dela.
      var critBase = node.dataset.relaxCrit || 'diameter';
      var critDir = node.dataset.relaxDir;
      var crit = (critDir && this.i18n['crit_' + critBase + '_' + critDir])
        || this.i18n['crit_' + critBase] || '';
      if (title) title.textContent = (few ? this.i18n.relax_title : this.i18n.cmp_more_title) || '';
      if (lead) lead.hidden = !few;
      if (text) text.textContent = fill(this.i18n.relaxed_ignored, { criterion: crit });
      if (deltaBox) {
        var ok = !isNaN(delta) && delta > 0;
        deltaBox.textContent = ok
          ? fill(plural(this.i18n.cmp_relax_delta, delta, this.plurals), { n: delta })
          : '';
        deltaBox.hidden = !ok;
      }
      if (link) link.href = url;
    }

    /* Filtry se v Search and Discovery mohou tise ignorovat. Radsi nic nez spatna lana. */
    sane(node, total) {
      var base = parseInt(node.dataset.base, 10) || 0;
      // Pri aktivni facetove alternative plati JEJI ocekavani a jeji facety -
      // kontrola proti cislum puvodni dlazdice by bud blokovala platny vysledek,
      // nebo pustila rozbity.
      var expect = this.altPick ? this.altPick.expect : parseInt(node.dataset.expect, 10);
      var hasFacets = this.altPick ? !!this.altPick.facets : !!node.dataset.facets;
      var bad = false;
      // data-expect je ocekavani z rozhodovaci logiky. Rozchod nic neblokuje (katalog
      // se meni casteji nez pruvodce), ale musi byt videt v konzoli.
      if (!isNaN(expect) && expect !== total) {
        console.warn(
          '[rope-wizard] kolekce ' + node.dataset.coll + ' vratila ' + total +
          ' polozek, logika ocekava ' + expect + '. Katalog se rozesel s pruvodcem.'
        );
      }
      // Dlazdice, ktera vedome sjednocuje vsechna pasma (data-expect == data-base),
      // vraci celou kolekci zamerne - heuristika "musi prijit min nez cela kolekce"
      // by ji falesne zablokovala. Kdyby u ni facety tise selhaly, prijde stejna
      // sada lan, takze tady o nic neprichazime. Sirsi pojistka proti celemu
      // katalogu (totalRopes) plati dal i pro ni.
      var expectsAll = !isNaN(expect) && base > 0 && expect >= base;
      if (total > this.totalRopes) bad = true;
      if (hasFacets && base && total >= base && !expectsAll) bad = true;
      if (hasFacets && total >= this.totalRopes) bad = true;
      if (!bad) return true;
      console.warn(
        '[rope-wizard] sanity check neprosel: kolekce ' + node.dataset.coll +
        ' vratila ' + total + ' polozek, ceka se mene nez ' + (base || this.totalRopes) +
        '. Facety pravdepodobne neprosly - vysledky nezobrazuji.'
      );
      this.showError('error_mismatch', node, null);
      return false;
    }

    showEmpty(node, len) {
      var loading = this.querySelector('[data-rw-loading]');
      var block = this.querySelector('[data-rw-results-block]');
      var errBox = this.querySelector('[data-rw-error]');
      var summary = this.querySelector('[data-rw-summary]');
      if (summary) summary.hidden = true;
      if (loading) loading.hidden = true;
      if (block) block.hidden = true;
      if (!errBox) return;
      errBox.hidden = false;
      var t = this.querySelector('[data-rw-error-title]');
      var x = this.querySelector('[data-rw-error-text]');
      var l = this.querySelector('[data-rw-error-link]');
      if (t) t.textContent = this.i18n.empty_title || '';
      if (x) x.textContent = this.i18n.empty_text || '';
      if (l) l.href = this.catalogLink(node, len);
    }

    showError(key, node, len) {
      var loading = this.querySelector('[data-rw-loading]');
      var block = this.querySelector('[data-rw-results-block]');
      var pick = this.querySelector('[data-rw-pick]');
      var errBox = this.querySelector('[data-rw-error]');
      var summary = this.querySelector('[data-rw-summary]');
      if (summary) summary.hidden = true;
      if (loading) loading.hidden = true;
      if (block) block.hidden = true;
      if (pick) pick.hidden = true;
      if (!errBox) return;
      errBox.hidden = false;
      var t = this.querySelector('[data-rw-error-title]');
      var x = this.querySelector('[data-rw-error-text]');
      var l = this.querySelector('[data-rw-error-link]');
      if (t) t.textContent = this.i18n.error_title || '';
      if (x) x.textContent = this.i18n[key] || '';
      if (l) l.href = node ? this.catalogLink(node, len) : this.catalogUrl;
    }

    /* ---------- srovnavaci seznam: razeni, vety, shodne u vsech ---------- */

    /* Osy razeni. Klic = hodnota data-sort na uzlu odpovedi, attr = strojovy
       data-tdn atribut. Zadna z nich se nikdy nepocita z toho, co neni ve vysledku. */

    /* Cachovane section_id v sessionStorage muze byt z uz prepsaneho template
       souboru (nove TID). Section Rendering API na nej vraci 404 nebo prazdnou
       odpoved. Zahodit ho a jednou zopakovat fetch bez nej - id se pak precte
       znovu z cele stranky. Vraci true, kdyz se opakovani spustilo. */
    dropSectionId(node, len, usedSid, err) {
      if (!usedSid || !this.sectionId) return false;
      console.warn('[rope-wizard] cachovane section_id neplati, opakuji bez nej', err || '');
      this.sectionId = null;
      try { sessionStorage.removeItem(SID_KEY); } catch (e) { /* private mode */ }
      this.lastSignature = null;
      this.loadResults(node, len, true);
      return true;
    }

    decorate(node) {
      var gridBox = this.querySelector('[data-rw-grid]');
      var ul = gridBox ? gridBox.querySelector('ul') : null;
      var common = this.querySelector('[data-rw-common]');
      var summary = this.querySelector('[data-rw-summary]');
      if (!ul) {
        if (common) common.hidden = true;
        if (summary) summary.hidden = true;
        return;
      }
      var items = Array.prototype.slice.call(ul.children).filter(function (li) {
        return li.nodeType === 1 && li.hasAttribute('data-tdn-rope');
      });
      if (!items.length) {
        if (common) common.hidden = true;
        if (summary) summary.hidden = true;
        return;
      }

      var axis = this.sortOverride || (this.altPick && this.altPick.sort) || node.dataset.sort || '';
      // Klientsky re-sort nad necelou strankou by seradil cast a tvaril se, ze
      // seradil vse. Radsi nerad it vubec, nez lhat.
      var paginated = typeof this.lastTotal === 'number' && this.lastTotal > items.length;
      var axisOk = !paginated && this.axisUsable(items, axis);
      if (axisOk) {
        items = this.sortItems(ul, items, axis);
      }

      this.markPick(node, items);
      this.buildHead(gridBox, ul, items);
      var missing = this.buildSentences(items, axisOk ? axis : '');
      this.buildCommon(items);
      this.updateSummary(axisOk ? axis : '', missing);
    }

    applySort() {
      if (this.lastNode) this.decorate(this.lastNode);
    }

    /* Zvyrazneni aktivni alternativy (razeni i facetove). aria-pressed rika
       ctecce, ze karta funguje jako prepinac, ne jako odkaz pryc. */
    syncAltState() {
      var self = this;
      var node = this.lastNode;
      this.querySelectorAll('[data-rw-alt]').forEach(function (a) {
        var n = a.dataset.rwAlt;
        var on = false;
        if (node) {
          var key = node.dataset['alt' + n + 'Sort'];
          if (key) {
            on = self.sortOverride === key;
          } else if (node.dataset['alt' + n + 'Facets'] !== undefined) {
            on = !!(self.altPick && self.altPick.n === n);
          }
        }
        a.classList.toggle('is-on', on);
        a.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    axisUsable(items, axis) {
      var cfg = RopeWizard.AXES[axis];
      if (!cfg || items.length < 2) return false;
      var known = 0;
      var certs = {};
      var certCount = 0;
      for (var i = 0; i < items.length; i++) {
        var v = attrNum(items[i], cfg.attr);
        if (v === null) continue;
        known += 1;
        if (axis === 'uiaa_desc') {
          var c = items[i].getAttribute('data-tdn-uiaa-cert') || '';
          if (!certs[c]) { certs[c] = true; certCount += 1; }
        }
      }
      // Pravidlo 7: pady UIAA se nesmi porovnavat napric certifikacemi. Kdyz jsou
      // ve vysledku dve ruzne, osa se nepouzije vubec - ani na razeni.
      if (axis === 'uiaa_desc' && certCount !== 1) return false;
      // Osa s pokrytim pod polovinu by shodila pulku vysledku dolu "protoze nevime".
      return known >= 2 && known * 2 > items.length;
    }

    sortItems(ul, items, axis) {
      var cfg = RopeWizard.AXES[axis];
      var dir = cfg.desc ? -1 : 1;
      // Array.prototype.sort je stabilni (ES2019+), takze pri remize zustava
      // poradi z kolekce. Chybejici hodnota jde vzdy na konec.
      var sorted = items.slice().sort(function (a, b) {
        var av = attrNum(a, cfg.attr);
        var bv = attrNum(b, cfg.attr);
        if (av === null && bv === null) return 0;
        if (av === null) return 1;
        if (bv === null) return -1;
        if (av !== bv) return av < bv ? -dir : dir;
        if (cfg.tie) {
          var at = attrNum(a, cfg.tie);
          var bt = attrNum(b, cfg.tie);
          if (at === null && bt === null) return 0;
          if (at === null) return 1;
          if (bt === null) return -1;
          if (at !== bt) return at < bt ? 1 : -1;
        }
        return 0;
      });
      sorted.forEach(function (li) { ul.appendChild(li); });
      return sorted;
    }

    /* Doporucene lano zustava ve vypisu a oznaci se az PO serazeni - jinak by
       nejlehci lano chybelo v seznamu, ktery tvrdi "Serazeno od nejlehciho". */
    /* Vrati desku s odduvodnenim tam, kde ji vyrenderoval Liquid. Vola se pred kazdym
       prekreslenim mrizky - deska totiz mezitim sedi uvnitr radku, ktery se zahodi. */
    restorePick() {
      var pick = this.pickBox;
      if (!pick || !this.pickHome || pick.parentNode === this.pickHome) return;
      pick.classList.remove('tdn-r-rw__pick-in-row');
      this.pickHome.insertBefore(pick, this.pickAnchor || null);
    }

    markPick(node, items) {
      var label = this.i18n.cmp_recommend_label || '';
      var pro = !!node.dataset.pro;
      var pickedTitle = '';
      var pickedRow = null;
      items.forEach(function (li, i) {
        var badge = li.querySelector('[data-tdn-pick-badge]');
        var on = !pro && i === 0;
        if (on) {
          li.setAttribute('data-tdn-pick', '');
          pickedTitle = li.getAttribute('data-tdn-title') || '';
          pickedRow = li;
        } else {
          li.removeAttribute('data-tdn-pick');
        }
        if (badge) {
          badge.textContent = on ? label : '';
          badge.hidden = !on;
        }
      });
      var pick = this.querySelector('[data-rw-pick]');
      if (pick) pick.hidden = pro;

      /* Odduvodneni patri k lanu, o kterem mluvi. Driv stalo jako samostatna deska
         NAD seznamem a jmeno i slovo "Doporucujeme" se tak behem 200 px opakovalo
         dvakrat. Ted se deska stehuje primo do oznaceneho radku. Lano zaroven
         zustava v seznamu, takze razeni dal nelze. */
      if (pickedRow && pick && !pro) {
        pick.classList.add('tdn-r-rw__pick-in-row');
        pickedRow.appendChild(pick);
      } else {
        this.restorePick();
      }
      // Nazev doporuceneho lana patri primo do desky. Bez nej zacinala argumentace
      // slovem "tohle", aniz by bylo receno co - ctenar musel nejdriv najit v seznamu
      // radek s pilulkou. Kdyz nazev chybi (nebo se nedoporucuje), radek se schova.
      var pickName = this.querySelector('[data-rw-pick-name]');
      if (pickName) {
        pickName.textContent = pickedTitle;
        pickName.hidden = !pickedTitle;
      }
    }

    /* Hlavicka sloupcu je mimo <ul>, aby nezasahovala do kontraktu se Section
       Rendering API ani do pruhovani :nth-child. Na mobilu ji CSS skryva a nazev
       parametru nese kazda bunka sama. */
    buildHead(gridBox, ul, items) {
      var old = gridBox.querySelector('.tdn-cmp__head');
      if (old) old.remove();
      var pay = !!items[0].querySelector('.tdn-cmp__cell--price');
      var head = document.createElement('div');
      head.className = 'tdn-cmp__head' + (pay ? '' : ' tdn-cmp__head--nopay');
      head.setAttribute('aria-hidden', 'true');
      var cols = ['', this.i18n.cmp_col_name, this.i18n.cmp_col_diameter, this.i18n.cmp_col_weight];
      // Posledni sloupec nese dve hodnoty (celkova cena + Kc/m), takze ho hlavicka
      // musi pojmenovat obe - jinak Kc/m visi pod zahlavim "Cena" bez vysvetleni.
      if (pay) cols.push(this.i18n.cmp_col_price_head || this.i18n.cmp_col_price);
      cols.forEach(function (t) {
        var s = document.createElement('span');
        s.textContent = t || '';
        head.appendChild(s);
      });
      gridBox.insertBefore(head, ul);
    }

    /* Generator rozlisujicich vet. Vsechny superlativy se pocitaji VYHRADNE nad
       polem radku aktualniho vysledku, nikdy nad katalogem - "nejlehci z techto
       sedmi" je pravda vzdy, "nejlehci lano TENDON" u jednoho lana z 24.
       Vraci pocet lan, kterym chybi nektery z porovnavanych parametru. */
    buildSentences(items, axis) {
      var self = this;
      var i18n = this.i18n;
      var n = items.length;
      var f = items.map(function (li) {
        return {
          li: li,
          title: li.getAttribute('data-tdn-title') || '',
          weight: attrNum(li, 'weight'),
          weightText: li.getAttribute('data-tdn-weight-text') || '',
          diameter: attrNum(li, 'diameter'),
          diameterText: li.getAttribute('data-tdn-diameter-text') || '',
          uiaa: attrNum(li, 'uiaa'),
          force: attrNum(li, 'force'),
          ppm: attrNum(li, 'ppm'),
          // Superlativy u ceny za metr se rozhoduji na ZOBRAZENE hodnote (cele Kc),
          // ne na presnych halerich. Jinak ze dvou lan, ktera obe ukazuji "39 Kč/m",
          // dostane vetu "Nejlevnejsi na metr" jen jedno - kvuli haleri, ktery
          // se nikde nevypisuje. Razeni dal jede na presne hodnote.
          ppmCzk: ppmDisp(li),
          ppmText: li.getAttribute('data-tdn-ppm-text') || '',
          cert: li.getAttribute('data-tdn-cert'),
          uprava: li.getAttribute('data-tdn-uprava'),
          upravaNone: li.hasAttribute('data-tdn-uprava-none'),
          out: []
        };
      });

      function known(key) {
        return f.filter(function (x) { return x[key] !== null && x[key] !== undefined; });
      }
      // Parametr "se v tomhle vysledku porovnava", kdyz ho zna aspon polovina lan.
      // U statickych lan tim UIAA vypadne z porovnani a pravidlo 4 kvuli nemu
      // nevypali u nikoho.
      function compared(key) {
        var k = known(key).length;
        return k >= 2 && k * 2 > n;
      }

      var uiaaText = function (v) {
        return fill(plural(i18n.cmp_uiaa_value, v, self.plurals), { n: v });
      };

      // ---- pravidlo 1 + 6/6b/6c: osa, kterou uzivatel zadal -------------------
      var cfg = RopeWizard.AXES[axis];
      if (cfg) {
        var key = cfg.key;
        // vkey = pole, na kterem se porovnava. U ceny za metr je to zaokrouhlena
        // zobrazovana hodnota (viz ppmCzk vyse), u ostatnich os primo klic.
        var vkey = key === 'ppm' ? 'ppmCzk' : key;
        var kn = known(key);
        var vals = kn.map(function (x) { return x[vkey]; });
        var best = cfg.desc ? Math.max.apply(null, vals) : Math.min.apply(null, vals);
        var winners = kn.filter(function (x) { return x[vkey] === best; });
        var counts = {};
        vals.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });

        if (winners.length === 1) {
          var w = winners[0];
          if (key === 'weight') {
            var rest = vals.filter(function (v) { return v !== best; }).sort(function (a, b) { return a - b; });
            var runner = rest[0];
            var d = Math.round(runner - best);
            var uniform = rest.every(function (v) { return v === runner; });
            if (uniform) {
              w.out.push(fill(i18n.cmp_lightest_all, { d: d }));
            } else {
              var second = kn.filter(function (x) { return x[key] === runner; })[0];
              w.out.push(fill(i18n.cmp_lightest, { d: d, title: second ? second.title : '' }));
            }
          } else if (key === 'diameter') {
            w.out.push(fill(i18n.cmp_thickest, { value: w.diameterText }));
          } else if (key === 'uiaa') {
            w.out.push(fill(i18n.cmp_most_falls, { value: uiaaText(w.uiaa) }));
          } else if (key === 'ppm') {
            var rel = relBelowRest(vals, best);
            if (rel >= 0.10) {
              w.out.push(fill(i18n.cmp_cheapest_pm, { price: w.ppmText, pct: Math.round(rel * 100) }));
            } else {
              w.out.push(fill(i18n.cmp_cheapest_pm_plain, { price: w.ppmText }));
            }
          }
        } else if (winners.length === 2) {
          // Pravidlo 6: pri remize dvou lan dostanou superlativ obe, s pojmenovanim
          // toho druheho. Pri remize tri a vic se pravidlo preskoci - superlativ,
          // ktery ma pulka vysledku, uz neni informace.
          winners.forEach(function (w2, idx) {
            var other = winners[1 - idx];
            if (key === 'weight') {
              w2.out.push(fill(i18n.cmp_lightest_tie, { value: w2.weightText, title: other.title }));
            } else if (key === 'diameter') {
              w2.out.push(fill(i18n.cmp_thickest_tie, { value: w2.diameterText, title: other.title }));
            } else if (key === 'uiaa') {
              w2.out.push(fill(i18n.cmp_most_falls_tie, { value: uiaaText(w2.uiaa), title: other.title }));
            } else if (key === 'ppm' && relBelowRest(vals, best) >= 0.10) {
              w2.out.push(fill(i18n.cmp_cheapest_pm_tie, { price: w2.ppmText, title: other.title }));
            }
          });
        }

        // Pravidlo 6c: 2. a 3. radek dostanou poradovou vetu, ale jen kdyz na sve
        // hodnote nikdo jiny nestoji. Bez toho by u vetve s remizou na prvnim miste
        // nemel vetu nikdo, prestoze seznam tvrdi, ze je serazeny.
        var ORD = {
          weight: ['cmp_rank2_weight', 'cmp_rank3_weight'],
          diameter: ['cmp_rank2_diameter', 'cmp_rank3_diameter'],
          uiaa: ['cmp_rank2_uiaa', 'cmp_rank3_uiaa'],
          ppm: ['cmp_rank2_ppm', 'cmp_rank3_ppm']
        };
        for (var p = 1; p <= 2 && p < f.length; p++) {
          var row = f[p];
          // "Druhe nejlehci ze dvou" nebo "treti ze tri" neni informace - posledni
          // radek poradovou vetu nedostava nikdy.
          if (p === f.length - 1) continue;
          if (row[key] === null || row[key] === undefined) continue;
          if (row[vkey] === best) continue;
          if (counts[row[vkey]] !== 1) continue;
          if (row.out.length) continue;
          var tpl = i18n[ORD[key][p - 1]];
          if (!tpl) continue;
          if (key === 'ppm') {
            row.out.push(fill(tpl, { price: row.ppmText }));
          } else if (key === 'uiaa') {
            row.out.push(fill(tpl, { value: uiaaText(row.uiaa) }));
          } else {
            row.out.push(fill(tpl, { value: key === 'weight' ? row.weightText : row.diameterText }));
          }
        }
      }

      // ---- pravidlo 2: unikatni kvalitativni vlastnost ------------------------
      // Uzavreny seznam kandidatu, aby se z generatoru nestal marketing. A vzdy
      // jen tehdy, kdyz hodnotu znaji VSECHNA lana - jinak "jedine" nejde dolozit
      // (Baymard: neznama hodnota se cte jako "tuhle vlastnost nema").
      if (f.every(function (x) { return x.cert; })) {
        var multi = f.filter(function (x) {
          return x.cert.indexOf('half') >= 0 && x.cert.indexOf('twin') >= 0;
        });
        if (multi.length === 1 && n > 1) push2(multi[0], i18n.cmp_uniq_half_twin);
      }
      if (f.every(function (x) { return x.uprava; })) {
        var byUpr = {};
        f.forEach(function (x) { (byUpr[x.uprava] = byUpr[x.uprava] || []).push(x); });
        if (Object.keys(byUpr).length > 1) {
          Object.keys(byUpr).forEach(function (k) {
            if (byUpr[k].length !== 1) return;
            var x = byUpr[k][0];
            push2(x, x.upravaNone
              ? i18n.cmp_uniq_untreated
              : fill(i18n.cmp_uniq_treated, { name: x.uprava }));
          });
        }
      }

      function push2(row, text) {
        if (text && row.out.length < 2) row.out.push(text);
      }

      // ---- pravidlo 3: cena za metr, jen pri rozdilu >= 10 % ------------------
      // Kdyz je osa zadani prave cena za metr, uz to rekla veta pravidla 1.
      // Na katalogovem trhu Kc/m neexistuje a pravidlo se cele preskoci.
      if (axis !== 'price_per_m_asc') {
        var kp = known('ppm');
        if (kp.length >= 2) {
          // opet na zobrazene hodnote v celych korunach, ne na halerich
          var pv = kp.map(function (x) { return x.ppmCzk; });
          var pmin = Math.min.apply(null, pv);
          var pw = kp.filter(function (x) { return x.ppmCzk === pmin; });
          var prel = relBelowRest(pv, pmin);
          if (prel >= 0.10) {
            if (pw.length === 1) {
              push2(pw[0], fill(i18n.cmp_cheapest_pm, { price: pw[0].ppmText, pct: Math.round(prel * 100) }));
            } else if (pw.length === 2) {
              pw.forEach(function (x, i) {
                push2(x, fill(i18n.cmp_cheapest_pm_tie, { price: x.ppmText, title: pw[1 - i].title }));
              });
            }
          }
        }
      }

      // ---- pravidlo 4: chybejici data. Nikdy prazdny radek. -------------------
      var need = ['weight', 'uiaa', 'force'].filter(compared);
      // Uprava je jediny parametr pravidla 4, ktery se zobrazuje pres buildCommon
      // (cip / radek "Shodne u vsech"). Musi proto sdilet jeho prah viditelnosti,
      // ne polovicni znalost jako ciselne sloupce - viz paramVisible().
      var upravaCompared = false;
      var uk = f.filter(function (x) { return x.uprava; }).length;
      if (uk >= 2 && paramVisible(n - uk, n)) upravaCompared = true;

      var missing = 0;
      f.forEach(function (x) {
        var gap = need.some(function (k) { return x[k] === null || x[k] === undefined; })
          || (upravaCompared && !x.uprava);
        if (gap) {
          missing += 1;
          // Pravidlo 5: nejvys dve vety na lano; priznani chybejicich dat ma prednost.
          if (x.out.length > 1) x.out.length = 1;
          x.out.push(i18n.cmp_incomplete);
        } else if (x.out.length > 2) {
          x.out.length = 2;
        }
        var ul = x.li.querySelector('[data-tdn-says]');
        if (!ul) return;
        ul.innerHTML = '';
        x.out.forEach(function (text, i) {
          var li = document.createElement('li');
          if (gap && i === x.out.length - 1) li.className = 'is-info';
          li.textContent = text;
          ul.appendChild(li);
        });
        ul.hidden = x.out.length === 0;
        if (x.out.length) ul.setAttribute('aria-label', i18n.cmp_says_label || '');
      });
      return missing;
    }

    /* Radek "Shodne u vsech N" + fakticke cipy. Jedna mechanika: co je napric
       vysledkem shodne, jde do radku pod seznamem; co se lisi, zustane jako cip
       na radku lana. Atribut, ktery nezna vic nez ~30 % lan, vypadne z obojiho -
       nema dost pokryti, aby o necem vypovidal. */
    buildCommon(items) {
      var box = this.querySelector('[data-rw-common]');
      var n = items.length;
      var parts = [];
      var partial = 0;

      RopeWizard.COMMON.forEach(function (a) {
        var vals = [];
        var unknown = 0;
        var disp = null;
        items.forEach(function (li) {
          var v = li.getAttribute('data-tdn-' + a.key);
          if (v === null || v === '') { unknown += 1; return; }
          if (vals.indexOf(v) === -1) vals.push(v);
          if (disp === null) disp = li.getAttribute('data-tdn-' + a.show) || v;
        });
        var drop = vals.length === 0 || !paramVisible(unknown, n);
        var same = !drop && vals.length === 1 && n > 1;
        items.forEach(function (li) {
          var chip = li.querySelector('[data-tdn-fact="' + a.fact + '"]');
          if (chip) chip.hidden = drop || same;
        });
        if (same) parts.push({ text: disp, unknown: unknown });
      });

      // Typ produktu a certifikace nesou u statickych lan tutez informaci
      // ("Statické lano" + "Statické"). Redundantni polozku zahodime driv, nez se
      // z ni spocita poznamka o neuplnych datech.
      var dupCommon = dropRedundant(parts.map(function (p) { return p.text; }));
      parts = parts.filter(function (p, i) { return !dupCommon[i]; });
      parts.forEach(function (p) { if (p.unknown > partial) partial = p.unknown; });

      // Tataz redundance na urovni jednoho lana: kdyz je ve vysledku statika
      // i dynamika, typ ani certifikace se neshoduji, oboje zustane jako cip
      // a na statickem radku by stalo "Statické lano · Statické".
      items.forEach(function (li) {
        var chips = Array.prototype.filter.call(
          li.querySelectorAll('[data-tdn-fact]'),
          function (c) { return !c.hidden; }
        );
        var dup = dropRedundant(chips.map(function (c) { return c.textContent; }));
        chips.forEach(function (c, i) { if (dup[i]) c.hidden = true; });
      });

      if (!box) return;
      if (!parts.length) { box.hidden = true; box.textContent = ''; return; }

      box.textContent = '';
      var label = document.createElement('b');
      label.textContent = fill(this.i18n.cmp_common_label, { n: n }) + ' ';
      box.appendChild(label);
      box.appendChild(document.createTextNode(parts.map(function (p) { return p.text; }).join(' · ')));
      if (partial > 0) {
        var note = document.createElement('span');
        note.className = 'tdn-r-rw__common-note';
        note.textContent = ' ' + fill(plural(this.i18n.cmp_common_partial, partial, this.plurals), { n: partial });
        box.appendChild(note);
      }
      box.hidden = false;
    }

    updateSummary(axis, missing) {
      var box = this.querySelector('[data-rw-summary]');
      if (!box) return;
      var sortNote = box.querySelector('[data-rw-sortnote]');
      var incomplete = box.querySelector('[data-rw-incomplete]');
      var sortText = axis ? this.i18n['cmp_sorted_' + axis] : '';
      if (sortNote) {
        sortNote.textContent = sortText || '';
        sortNote.hidden = !sortText;
      }
      if (incomplete) {
        var t = missing > 0
          ? fill(plural(this.i18n.cmp_incomplete_note, missing, this.plurals), { n: missing })
          : '';
        incomplete.textContent = t;
        incomplete.hidden = !t;
      }
      box.hidden = !sortText && !(missing > 0);
    }

    /* Karty potrebuji CSS a JS kolekce; z odpovedi si je pujcime, ale jen jednou. */
    absorbAssets(doc, wrap) {
      var have = {};
      Array.prototype.forEach.call(document.querySelectorAll('link[rel="stylesheet"]'), function (l) {
        have[l.href] = true;
      });
      Array.prototype.forEach.call(doc.querySelectorAll('link[rel="stylesheet"][href]'), function (l) {
        var abs = new URL(l.getAttribute('href'), window.location.origin).href;
        if (have[abs]) return;
        have[abs] = true;
        var n = document.createElement('link');
        n.rel = 'stylesheet';
        n.href = abs;
        document.head.appendChild(n);
      });

      var scope = wrap || doc;
      var haveJs = {};
      Array.prototype.forEach.call(document.querySelectorAll('script[src]'), function (s) {
        haveJs[s.src] = true;
      });
      Array.prototype.forEach.call(scope.querySelectorAll('script[src]'), function (s) {
        var abs = new URL(s.getAttribute('src'), window.location.origin).href;
        if (haveJs[abs]) return;
        haveJs[abs] = true;
        var n = document.createElement('script');
        n.src = abs;
        n.defer = true;
        document.head.appendChild(n);
      });
    }
  }

  /* Osy razeni. Klic = hodnota data-sort na uzlu odpovedi. Osa se pouzije jen
     tehdy, kdyz ji uzivatel skutecne zadal (nebo kdyz mu pruvodce na tyz obrazovce
     tvrdi kompromis v teto ose) - jinak zustava poradi z kolekce a pruh o razeni mlci. */
  RopeWizard.AXES = {
    weight_asc: { key: 'weight', attr: 'weight', desc: false },
    diameter_desc: { key: 'diameter', attr: 'diameter', desc: true },
    uiaa_desc: { key: 'uiaa', attr: 'uiaa', desc: true, tie: 'diameter' },
    price_per_m_asc: { key: 'ppm', attr: 'ppm', desc: false }
  };

  /* Atributy, ktere se porovnavaji napric vysledkem. Shodne jdou do radku
     "Shodne u vsech N", rozdilne zustanou jako fakticky cip na radku lana.
     key = podle ceho se porovnava, show = co se zobrazi, fact = data-tdn-fact cipu. */
  RopeWizard.COMMON = [
    { key: 'type', show: 'type', fact: 'type' },
    { key: 'cert-text', show: 'cert-text', fact: 'cert' },
    { key: 'norma', show: 'norma', fact: 'norma' },
    { key: 'uprava', show: 'uprava', fact: 'uprava' },
    { key: 'lengths', show: 'lengths-text', fact: 'lengths' }
  ];

  if (!customElements.get('rope-wizard')) {
    customElements.define('rope-wizard', RopeWizard);
  }
})();
